// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-xuanzhong11[data-v-9c274066] {\n  cursor: pointer;\n  font-size: 16px;\n  margin-left: 10px;\n  cursor: pointer;\n  color: var(--prev-color-primary);\n}\n.icon-weixuan[data-v-9c274066] {\n  cursor: pointer;\n  font-size: 16px;\n  margin-left: 10px;\n  cursor: pointer;\n  color: #cccccc;\n}", ""]);
// Exports
module.exports = exports;
